<div class="details-popin_container">
  <h1 class="details-popin_title">{{ title }}</h1>
  <div class="details-popin_content">
    <p class="text">{{ description?.long_1 }}</p>
    <p class="text">{{ description?.long_2 }}</p>
    <p class="text">{{ description?.long_3 }}</p>
    <p class="text">{{ description?.long_4 }}</p>
    <p class="text">{{ description?.long_5 }}</p>
  </div>
  <rc-button data-qa="vs-nutritional-criteria-details-popin-button-close" type="submit" (click)="dismiss()">
    {{ 'action_close' | translateKey }}
  </rc-button>
</div>
